export default __webpack_public_path__ + "static/media/DJVADIM-1920.32f4a5b1.webp";